import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type AncestorFolderInfoFragment = { __typename?: 'AncestorFolder', id: string, name?: string | null };

export const AncestorFolderInfo = /*#__PURE__*/ gql`
    fragment AncestorFolderInfo on AncestorFolder {
  id
  name
}
    ` as unknown as DocumentNode<AncestorFolderInfoFragment, unknown>;

        

        
export const useAncestorFolderInfoFragment = (
  input: string | Omit<UseFragmentOptions<AncestorFolderInfoFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'AncestorFolder' } };
    return input;
  })();

  return useFragment<AncestorFolderInfoFragment>({
    fragment: AncestorFolderInfo,
    fragmentName: 'AncestorFolderInfo',
    ...options,
  });
};
  
        